import { createRouter, createWebHistory } from "vue-router"
import Home from "@/components/AppHome.vue"
import Privacy from "@/components/PrivacyPolicy.vue"
import TermsOfUse from "@/components/TermsOfUse.vue";
import ProductSupport from "@/components/ProductSupport.vue";
import Products from "@/components/ProductsLanding.vue";
import ProductDetail from "@/components/ProductDetail.vue";
import PageNotFound from "@/components/PageNotFound.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/products",
    name: "products",
    component: Products,
  },
  {
    path: "/products/:slug",
    name: "product-detail",
    component: ProductDetail,
  },
  {
    path: "/products/pulse-forge",
    redirect: "/products/cardioforge",
  },
  {
    path: "/privacy",
    name: "privacy",
    component: Privacy,
  },
  {
    path: "/terms",
    name: "terms",
    component: TermsOfUse,
  },
  {
    path: "/support",
    name: "support",
    component: ProductSupport,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "page-not-found",
    component: PageNotFound,
  }
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // Always scroll to top
    return { top: 0 }
  },
})

export default router
